module.exports = __webpack_public_path__ + "img/opcion-multiple.5e003cdc.svg";